var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a6 6 0 0 1 6-6h32a6 6 0 0 1 6 6v19.429a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V18Z",
    fill: "#01326F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.663 20.302h-8.249v14.825h8.25V20.302Z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.938 27.716a9.413 9.413 0 0 1 3.6-7.414 9.428 9.428 0 1 0 0 14.825 9.412 9.412 0 0 1-3.6-7.41Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.792 27.716a9.428 9.428 0 0 1-15.254 7.41 9.427 9.427 0 0 0 0-14.824 9.427 9.427 0 0 1 15.254 7.411v.003Z",
    fill: "#F79E1B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.421ad1b2.svg";
export { ForwardRef as ReactComponent };